import TranslatorsTable from 'components/mediators/Tables/Translators'
import React from 'react'

const Translators = () => {
  return (
    <TranslatorsTable />
  )
}

export default Translators
